import styled from 'styled-components'

export const StyledRootContainer = styled.div`
  display: flex;
`;

export const StyledMainContainer = styled.main`
  min-height: 100vh;
  width: 100%;
  padding: ${({auth}) => auth ? '100px 20px 20px' : '15px'};
  background-color: ${({theme}) => theme.body.background};
  flex-grow: 1;
  position: relative;
  overflow-x: hidden;
  @media screen and (max-width: 992px) {
    // зліва: ширина згорнутого drawer (58px, він тут position: absolute) + той самий відступ 15px
    padding: ${({auth}) => auth ? '100px 15px 15px 73px' : '15px'};
  }
  @media screen and (max-width: 599px) {
    padding: ${({auth}) => auth ? '80px 15px 15px 15px' : '15px'};
  }
`;

export const StyledContentWrapper = styled.div`
  min-height: ${({height}) => height === 'auto' ? 'auto' : 'calc(100vh - 120px)'};
  padding: 20px;
  background-color: ${({theme}) => theme.surface.background};
  border: 1px solid ${({theme}) => theme.surface.border};
  border-radius: 5px;
  box-shadow: 0 2px 4px ${({theme}) => theme.surface.shadow};
  @media screen and (max-width: 599px) {
    padding: 20px 15px;
  }
`;
